import { z } from 'zod'

export const STRATALYST_ANALYSIS_RECIPE_EXECUTOR_CONTRACT_VERSION = '1.0.0' as const
export const stratalystAnalysisRecipeExecutorResponseSchema = z.unknown()
export type StratalystAnalysisRecipeExecutorResponse = z.infer<typeof stratalystAnalysisRecipeExecutorResponseSchema>
